import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import {SalesNetwork} from '../../models/sales-network.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';

@Injectable()
export class SalesNetworkService {

  salesNetworks: SalesNetwork[];
  //salesNetworkEditing: SalesNetwork;


  private cachedFields: Observable<any>
  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }


  /*
  getAll(division_id?: number) {
    return this.h.get('/koncentro-common/sales-networks'.concat(division_id ? '?division_id=' + division_id : ''))
      .map(res => {
        return this.salesNetworks = res;
      });
  }
  */
 getAll(division_id?: number) {
  return this.h.get('/koncentro-common/sales-networks/getSalesNetworkList'.concat(division_id ? '?division_id=' + division_id : ''))
    .map(res => {
      return this.salesNetworks = res;
    });
}

  delete(record) {
    return this.h.delete('/koncentro-common/sales-networks/' + record.id)
      .map(res => {
        this.salesNetworks.splice(this.salesNetworks.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Sales network deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/sales-networks', newData)
      .map(res => {
        newData.id = res.id;
        this.salesNetworks.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put('/koncentro-common/sales-networks', newData)
      .map(res => {        
        //Object.assign(this.salesNetworkEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/SalesNetworkDto ').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/sales-network/sales-network.service.ts